<template>
  <v-card flat class="special_conditions">
    <v-card-text>
      <v-card flat class="pa-4">
        <v-card-text>
          <h3>PETS:</h3>
          <v-layout column>
            <v-flex xs12>
              <v-layout column>
                <v-flex xs12 class="pt-3">
                  <v-checkbox
                    label="I will be travelling with pets"
                    v-model="pets"
										@click.native="restricted()"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 v-if="pets === true">
                  <v-layout column>
                    <v-flex xs12>
                      <v-checkbox
                        label="Dog 20 lbs and under"
                        v-model="dog"
                        @click.native="restricted()"
                      ></v-checkbox>
                      <v-flex xs12 v-if="dog === true">
                        Upon check-in, the dog will be weighed, and transported free of charge (does not count towards luggage allotment). The dog will sit on the owner's lap with a dog harness (either supplied by the owner or by Seair Seaplanes), as well as, a Seair Seaplanes supplied seat belt attachment. For other travel alternatives, please contact us at <a href="tel:1-800-447-3247">1-800-447-3247</a>.
                        <a href="/schedules-fares/cargo-pets/" target="_blank">Learn more</a>.
                      </v-flex>
                    </v-flex>
                    <v-flex xs12  class="pt-3">
                      <v-checkbox
                        label="Dog 21 lbs and above"
                        v-model="large_dog"
                        @click.native="restricted()"
                      ></v-checkbox>
                      <v-flex xs12 class="warning" v-if="large_dog === true">
                        <v-icon class="pt-2 mr-2">error</v-icon>
                        Additional costs and booking restrictions apply. Please call us to book via phone
                        at <a href="tel:1-800-447-3247">1-800-447-3247</a>.
                        <a href="/schedules-fares/cargo-pets/" target="_blank">Learn more</a>.
                      </v-flex>
                    </v-flex>
                    <v-flex xs12  class="pt-3">
                      <v-checkbox
                        label="Cats, Birds, or Other Small Pets"
                        v-model="cat"
                        @click.native="restricted()"
                      ></v-checkbox>
                      <v-flex xs12 class="warning" v-if="cat === true">
                        <v-icon class="pt-2 mr-2">error</v-icon>
												Cats must be in a small, soft carrier and will sit on owner’s lap and will be supplied with a Seair seatbelt attachment. Cats on lap will be transported free of charge and will not count towards luggage allotment.<br>
												<br>
                        All animals must be in a hard shell, travel case and will be secured in the cargo area. The weight of the animal and the case goes against the owner’s allotted passenger baggage weight and if over, excess baggage charges will apply. See above excess baggage chart for rates.
												<a href="/schedules-fares/cargo-pets/" target="_blank">Learn more</a>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-card flat class="pa-4">
        <v-card-text>
          <h3>SPECIAL CONDITIONS:</h3>
          <v-layout column>
            <v-flex xs12>
              <v-layout column>
                <v-flex xs12 class="pt-3">
                  <v-checkbox
                    label="I will need assistance in boarding"
                    v-model="assistance"
                    @click.native="restricted()"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 class="warning mb-3 pl-3" v-if="assistance === true">
                  <v-icon class="pt-2 mr-2">error</v-icon>
                  If you require assistance with boarding, please contact
                  <a href="tel:1-800-447-3247">1-800-447-3247</a>, prior to reserving your flight.
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import Shared from "@/mixins/Shared.js";
import { createHelpers } from "vuex-map-fields";

const { mapFields } = createHelpers({
  getterType: "getField",
  mutationType: "updateField",
});

export default {
  name: "SpecialConditions",
  computed: {
    ...mapFields([
      "cargoDialog",
      "conditions.pets",
      "conditions.dog",
      "conditions.large_dog",
      "conditions.cat",
      "conditions.assistance"
    ]),
  },
  mixins: [Shared],
  watch: {
    pets(val) {
      if (val === false) {
        this.dog = false;
        this.large_dog = false;
        this.cat = false;
        this.restricted();
      }
    }
  },
  methods: {
    restricted() {
			if(
				this.pets === true &&
				this.dog === false &&
				this.large_dog === false &&
				this.cat === false
			)
			{
				this.setError(
					"Passengers",
					"Please select the type of pet(s) you will be travelling with."
				);
			}
			else
			{
				this.$store.dispatch("UNSET_ERRORS", "Passengers");
        this.validatePassengerDetails();

				if (
					this.large_dog === true ||
          this.cat === true ||
					this.assistance === true
				) {
					this.setError(
						"Passengers",
						"Special conditions apply to your booking. Please call <a href=\"tel:1-800-447-3247\">1-800-447-3247</a> prior to reserving your flight."
					);
				} else {
					this.$store.dispatch("UNSET_ERRORS", "Passengers");
					this.validatePassengerDetails();
				}
			}
    }
  }
}
</script>
